import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  label: {
    display: 'flex !important',
    alignItems: 'center',
    width: 'fit-content',
  },
}));

export default useStyles;
